export const FIELD_CATEGORY_PROPERTY = 'property';
export const FIELD_CATEGORY_UNIT = 'unit';
export const FIELD_CATEGORY_CLAIM = 'claim';
